__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "openshift-console";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@openshift-console/dynamic-plugin-sdk-internal", "0.0.0-fixed", () => (() => (__webpack_require__(606202))), 1);
			register("@openshift-console/dynamic-plugin-sdk", "0.0.0-fixed", () => (() => (__webpack_require__(349448))), 1);
			register("@openshift/dynamic-plugin-sdk", "8.0.0", () => (() => (__webpack_require__(545992))), 1);
			register("@patternfly/react-topology", "6.4.0", () => (() => (__webpack_require__(668563))), 1);
			register("react-i18next", "15.1.4", () => (() => (__webpack_require__(778291))), 1);
			register("react-redux", "8.1.3", () => (() => (__webpack_require__(349924))), 1);
			register("react-router-dom-v5-compat", "6.11.2", () => (() => (__webpack_require__(939937))), 1);
			register("react-router-dom", "5.3.4", () => (() => (__webpack_require__(354625))), 1);
			register("react-router", "5.3.4", () => (() => (__webpack_require__(956347))), 1);
			register("react-router", "6.11.2", () => (() => (__webpack_require__(754148))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(296540))), 1);
			register("redux-thunk", "2.4.0", () => (() => (__webpack_require__(901265))), 1);
			register("redux", "4.0.4", () => (() => (__webpack_require__(82960))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};